module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/428.05ea5a58.png";